export const blockIconsPrivacyandsecurityPasskeyNew = (
	<span className='material-symbols-outlined'>passkey</span>
);
